import React from "react";

// SVG silhouette laterale auto, grigio scuro su sfondo grigio chiaro.
// Nessun testo. Usato come placeholder copertina veicolo.
export default function CarPlaceholderSvg({ className = "" }) {
  return (
    <svg
      viewBox="0 0 120 80"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <rect width="120" height="80" fill="#e2e8f0" />
      <g fill="#94a3b8">
        {/* Carrozzeria + tetto */}
        <path d="M14 52
                 Q14 44 22 42
                 L40 36
                 Q46 30 55 30
                 L78 30
                 Q86 30 93 36
                 L102 40
                 Q108 42 108 50
                 L108 56
                 Q108 60 104 60
                 L96 60
                 A8 8 0 0 0 80 60
                 L42 60
                 A8 8 0 0 0 26 60
                 L18 60
                 Q14 60 14 56
                 Z" />
        {/* Finestrini (negativo, chiaro) */}
        <path d="M44 36 L55 32 L70 32 L72 36 Z" fill="#cbd5e1" />
        <path d="M74 36 L76 32 L83 33 L90 36 Z" fill="#cbd5e1" />
      </g>
      {/* Ruote */}
      <circle cx="34" cy="60" r="6" fill="#475569" />
      <circle cx="88" cy="60" r="6" fill="#475569" />
      <circle cx="34" cy="60" r="2.4" fill="#cbd5e1" />
      <circle cx="88" cy="60" r="2.4" fill="#cbd5e1" />
    </svg>
  );
}
